'use client';

import Script from 'next/script';
import { IHubSpotForm } from './types';
import { extractHubSpotFormData } from '@/utils/helpers';
import { useEffect, useState } from 'react';
import HubSpotFormSkeleton from './HubSpotFormSkeleton';

export default function HubSpotStandardForm(props: IHubSpotForm) {
  const { embedCode } = props;
  const { scriptSrc, portalId, formId, region } = extractHubSpotFormData(embedCode);
  const [isFormReady, setIsFormReady] = useState(false);

  useEffect(() => {
    const handleFormReady = () => {
      setIsFormReady(true);
    };

    window.addEventListener('hs-form-event:on-ready', handleFormReady);
    return () => {
      window.removeEventListener('hs-form-event:on-ready', handleFormReady);
    };
  }, [formId]);

  if (!embedCode) {
    return null;
  }

  return (
    <div>
      {!isFormReady && <HubSpotFormSkeleton />}
      <Script charSet='utf-8' type='text/javascript' src={scriptSrc}></Script>
      <div className='hs-form-frame' data-region={region} data-form-id={formId} data-portal-id={portalId}></div>
    </div>
  );
}
